const buildUrl = (href: string, data: object, marker = '{}') => {
  if (!isMarkerPresent(href, marker)) return href;
  let result = href;
  const startMarker = marker[0];
  const endMarker = marker[1];

  const regex = new RegExp(`${startMarker}(.*?)${endMarker}`, 'g');
  const matches = result.match(regex) || [];

  for (const match of matches) {
    const property = extractPropertyFromMarker(match, marker);
    if (property) {
      // Handle nested properties using property path
      const value = getNestedValue(data, property);
      if (value !== undefined) {
        result = result.replace(match, value);
      }
    }
  }

  return result;
};

// New helper function to get values from nested objects
const getNestedValue = (obj: any, path: string): any => {
  if (!obj || !path) return undefined;
  
  const properties = path.split('.');
  let value = obj;
  
  for (const prop of properties) {
    if (value === undefined || value === null) return undefined;
    value = value[prop];
  }
  
  return value;
};

const isMarkerPresent = (text: string, marker = '{}') => {
  const startMarker = marker[0];
  const endMarker = marker[1];
  const regex = new RegExp(`${startMarker}.*?${endMarker}`);
  return regex.test(text);
};

const extractPropertyFromMarker = (text: string, marker: string) => {
  if (text === "" || text == undefined || text == null || marker.length < 2) {
    return null;
  }
  const startMarker = marker[0];
  const endMarker = marker[1];
  
  // Extract content between markers (without including the markers)
  const startIndex = text.indexOf(startMarker);
  const endIndex = text.lastIndexOf(endMarker);
  
  if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex) {
    return null;
  }
  
  return text.substring(startIndex + 1, endIndex);
};

const buildQueryParams = (query: object): string => {
  if (query == undefined || query == null) return "";
  const params = new URLSearchParams("")

  for (const [key, value] of Object.entries(query)) {
    params.append(key, value);
  }
  return "?" + params.toString();
}

export { buildUrl, buildQueryParams }

